import { Profile } from '../../../../api/api-profile';
import * as types from '../constants/action-types';

const fetchReferralBalanceRequest = () => {
  return {
    type: types.FETCH_REFERRAL_BALANCE_REQUEST
  };
};

const fetchReferralBalanceSuccess = (data) => {
  return {
    type: types.FETCH_REFERRAL_BALANCE_SUCCESS,
    data
  };
};

const fetchReferralBalanceFailure = (error) => {
  return {
    type: types.FETCH_REFERRAL_BALANCE_FAILURE,
    error
  };
};

export const fetchReferralBalance = (ssoId, token) => {
  return dispatch => {
    dispatch(fetchReferralBalanceRequest());
    Profile.readCredits(ssoId, token, (response) => {
      if (response.error) {
        return dispatch(fetchReferralBalanceFailure(response.error));
      }

      return dispatch(fetchReferralBalanceSuccess(response));

    }, '?creation_source=GUEST_REFERRAL_FEE');
  }
};
